module.exports = __webpack_public_path__ + "media/assets/icon-heart-03bad17eb7bc978edbadb03a9f570d52.svg";